<template>
  <div class="main-content">
    <!-- 列表页 -->
    <div v-if="showFlag">
      <el-form :inline="true" :model="searchForm" class="form-content">
        <el-row :gutter="20" class="slt">
          <el-form-item label="新闻标题">
            <el-input v-model="searchForm.title" placeholder="新闻标题" clearable></el-input>
          </el-form-item>
          <el-form-item label="新闻状态">
            <el-select v-model="searchForm.status" placeholder="新闻状态" clearable>
              <el-option label="未发布" :value="0"></el-option>
              <el-option label="已发布" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="新闻类型">
            <el-select v-model="searchForm.type" placeholder="新闻类型" clearable>
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search()">查询</el-button>
            <el-button @click="resetFilter">重置</el-button>
          </el-form-item>
        </el-row>
        <el-row class="ad">
          <el-form-item>
            <el-button type="primary" @click="addOrUpdateHandler()">新增</el-button>
            <el-button type="danger" :disabled="dataListSelections.length <= 0" @click="deleteBatchHandler()">删除
            </el-button>
          </el-form-item>
        </el-row>
      </el-form>
      <div class="table-content">
        <el-table
            :data="dataList"
            border
            v-loading="dataListLoading"
            @selection-change="selectionChangeHandler"
            style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
          <el-table-column prop="title" label="新闻标题" width="195"></el-table-column>
          <el-table-column prop="image" label="图片" width="140">
            <template slot-scope="scope">
              <el-image
                  style="width: 100px; height: 60px" fit="contain"
                  :src="$store.state.baseApi + scope.row.image"
                  :preview-src-list="[$store.state.baseApi + scope.row.image]">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="publishTime" label="发布日期" width="160">
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.publishTime) }}
            </template>
          </el-table-column>
          <el-table-column prop="summary" label="简介" min-width="230"></el-table-column>
          <el-table-column prop="type" label="新闻类型" width="91">
            <template slot-scope="scope">
              <el-tag :type="getTopicTagType(scope.row.type)" effect="plain">
                {{ getSubjectLabel(scope.row.type) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="80">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 0 ? 'danger' : 'success'">
                {{ scope.row.status === 0 ? '未发布' : '已发布' }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="330">
            <template slot-scope="scope">
              <el-button size="mini" @click="addOrUpdateHandler(scope.row.id,'info')">详情</el-button>
              <el-button size="mini" type="primary" @click="addOrUpdateHandler(scope.row.id)">修改</el-button>
              <el-button size="mini" type="danger" @click="deleteHandler(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <div class="block">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              background
              :current-page="currentPage"
              :page-sizes="[8,16,24,32]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 添加/修改页面 -->
    <add-or-update v-if="addOrUpdateFlag" :parent="this" ref="addOrUpdate"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./newsList.vue"

const TypeEnum = {
  COMPANY: '公司咨询',
  INDUSTRY: '行业新闻',
  NOTICE: '通知公告'
};
export default {
  components: {AddOrUpdate},
  data() {
    return {
      searchForm: {
        title: '',
        status: '',
        type: '',
      },
      currentPage: 1,
      pageSize: 8,
      dataList: [],
      total: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      addOrUpdateFlag: false,
      statusOptions: Object.entries(TypeEnum).map(([value, label]) => ({value, label})),
    }
  },
  created() {
    this.getDataList();
  },
  methods: {
    getSubjectLabel(value) {
      return TypeEnum[value] || value;
    },
    getTopicTagType(subject) {
      const types = {
        'COMPANY': 'primary',
        'INDUSTRY': 'warning',
        'NOTICE': 'info',
      };
      return types[subject] || '';
    },
    resetFilter() {
      this.searchForm.title = '';
      this.searchForm.status = '';
      this.searchForm.type = '';
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getDataList();
    },
    search() {
      this.currentPage = 1;
      this.getDataList();
    },
    getDataList() {
      this.dataListLoading = true;
      this.$api.getNewsList({
        page: this.currentPage,
        nums: this.pageSize,
        title: this.searchForm.title,
        status: this.searchForm.status,
        ...(this.searchForm.type ? {type: this.searchForm.type} : {}),
      }).then(res => {
        if (res.code == 200) {
          const mockData = res.data.list;
          this.dataList = mockData.map((item, index) => ({
            ...item,
            index: index + 1
          }));
          this.total = res.data.total;
        }
        this.dataListLoading = false;
      });
    },
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    addOrUpdateHandler(id, type) {
      this.showFlag = false;
      this.addOrUpdateFlag = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, type || 'else');
      });
    },
    deleteHandler(id) {
      this.$confirm(`确定删除选中的记录?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$api.deleteNews({
          id: id
        }).then(res => {
          if (res.code === 200) {
            this.$message.success(res.message);
            this.search();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    deleteBatchHandler() {
      const newsIds = this.dataListSelections.map(item => item.id);
      this.$confirm(`确定删除选中的记录?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$api.deleteNewsList({
          newsIds: newsIds
        }).then(res => {
          if (res.code === 200) {
            this.$message.success(res.message);
            this.search();
          }
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      })
    },
    formatDateTime(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  }
}
</script>

<style scoped>
.slt, .ad {
  margin: 0;
  display: flex;
}

.block {
  display: flex;
  justify-content: center;
  padding-top: 15px;
  padding-bottom: 10px;
  width: 100%;
}
</style>